const localesToIso = { 'el': 'GR', 'fr': 'FR', 'es': 'ES', 'it': 'IT', 'de': 'DE', 'bg': 'BG', 'pt': 'PT', 'pl': 'PL', 'hr': 'HR', 'sq': 'AL', 'tr': 'TR', 'sv': 'SE', 'da': 'DK', 'nl': 'NL' };

/**
 * Converts a locale to an ISO country code
 * @param {string} locale
 */
export const IsoFromLocale = (locale) => localesToIso[locale] || '';